<template>
    <div class="page-container home-wrapper relative">
        <media-swiper :list="list" urlKey="link" v-if="$store.state.cw >= 768" />
    </div>
</template>

<script>
import MediaSwiper from '@/components/feature/MediaSwiper.vue';

export default {
    name: 'home',

    components: {
        MediaSwiper,
    },

    data() {
        return {
            list: [],
        };
    },

    methods: {
        fetchBanner() {
            this.$http.getHomeBanner().then((res) => {
                this.list = res;
            });
        },
    },

    created() {
        this.fetchBanner();
    },

    mounted() {},
};
</script>

<style lang="scss" scoped></style>
